export default "__VITE_ASSET__BI0K7U86__"